import * as React from 'react';
export var Discount = function (_a) {
    var color = _a.color;
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1.07em", viewBox: "0 0 16 17", fill: "none", color: color },
        React.createElement("path", { d: "m5.217 11.368 5.566-5.565M6.457 6.499a.543.543 0 1 1-1.087 0 .543.543 0 0 1 1.087 0ZM10.63 10.673a.543.543 0 1 1-1.087 0 .543.543 0 0 1 1.087 0Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }),
        React.createElement("path", { d: "M15.5 8.586a7.5 7.5 0 1 1-15 0 7.5 7.5 0 0 1 15 0Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" })));
};
